module.exports = __webpack_public_path__ + "img/icon_menu_certificacion_child_count.7f81bd74.svg";